import type { NumberSpeller } from './types'

// Punjabi (Gurmukhi) has an irregular word for every number 0–99.
const BELOW_100 = [
  'ਸਿਫ਼ਰ', 'ਇੱਕ', 'ਦੋ', 'ਤਿੰਨ', 'ਚਾਰ', 'ਪੰਜ', 'ਛੇ', 'ਸੱਤ', 'ਅੱਠ', 'ਨੌਂ',
  'ਦਸ', 'ਗਿਆਰਾਂ', 'ਬਾਰਾਂ', 'ਤੇਰਾਂ', 'ਚੌਦਾਂ', 'ਪੰਦਰਾਂ', 'ਸੋਲਾਂ', 'ਸਤਾਰਾਂ', 'ਅਠਾਰਾਂ', 'ਉੱਨੀ',
  'ਵੀਹ', 'ਇੱਕੀ', 'ਬਾਈ', 'ਤੇਈ', 'ਚੌਵੀ', 'ਪੱਚੀ', 'ਛੱਬੀ', 'ਸਤਾਈ', 'ਅਠਾਈ', 'ਉਨੱਤੀ',
  'ਤੀਹ', 'ਇਕੱਤੀ', 'ਬੱਤੀ', 'ਤੇਤੀ', 'ਚੌਂਤੀ', 'ਪੈਂਤੀ', 'ਛੱਤੀ', 'ਸੈਂਤੀ', 'ਅਠੱਤੀ', 'ਉਨਤਾਲੀ',
  'ਚਾਲੀ', 'ਇਕਤਾਲੀ', 'ਬਿਆਲੀ', 'ਤਿਰਤਾਲੀ', 'ਚੁਤਾਲੀ', 'ਪੰਤਾਲੀ', 'ਛਿਆਲੀ', 'ਸੰਤਾਲੀ', 'ਅਠਤਾਲੀ', 'ਉਨੰਜਾ',
  'ਪੰਜਾਹ', 'ਇਕਵੰਜਾ', 'ਬਵੰਜਾ', 'ਤਰਵੰਜਾ', 'ਚਰਵੰਜਾ', 'ਪਚਵੰਜਾ', 'ਛਪੰਜਾ', 'ਸਤਵੰਜਾ', 'ਅਠਵੰਜਾ', 'ਉਨਾਹਠ',
  'ਸੱਠ', 'ਇਕਾਹਠ', 'ਬਾਹਠ', 'ਤਰੇਹਠ', 'ਚੌਂਹਠ', 'ਪੈਂਹਠ', 'ਛਿਆਹਠ', 'ਸਤਾਹਠ', 'ਅਠਾਹਠ', 'ਉਨੱਤਰ',
  'ਸੱਤਰ', 'ਇਕਹੱਤਰ', 'ਬਹੱਤਰ', 'ਤਿਹੱਤਰ', 'ਚੌਹੱਤਰ', 'ਪਚੱਤਰ', 'ਛਿਹੱਤਰ', 'ਸਤੱਤਰ', 'ਅਠੱਤਰ', 'ਉਨਾਸੀ',
  'ਅੱਸੀ', 'ਇਕਾਸੀ', 'ਬਿਆਸੀ', 'ਤਿਰਾਸੀ', 'ਚੁਰਾਸੀ', 'ਪਚਾਸੀ', 'ਛਿਆਸੀ', 'ਸਤਾਸੀ', 'ਅਠਾਸੀ', 'ਉਨੱਨਵੇਂ',
  'ਨੱਬੇ', 'ਇਕਾਨਵੇਂ', 'ਬਾਨਵੇਂ', 'ਤਿਰਾਨਵੇਂ', 'ਚੁਰਾਨਵੇਂ', 'ਪਚਾਨਵੇਂ', 'ਛਿਆਨਵੇਂ', 'ਸਤਾਨਵੇਂ', 'ਅਠਾਨਵੇਂ', 'ਨੜਿੰਨਵੇਂ'
]

function below1000(n: number): string {
  const h = Math.floor(n / 100)
  const r = n % 100
  return [h ? `${BELOW_100[h]} ਸੌ` : '', r ? BELOW_100[r] : ''].filter(Boolean).join(' ')
}

function spell(n: number): string {
  if (n === 0) return BELOW_100[0]
  const parts: string[] = []
  const units: Array<[number, string]> = [[10_000_000, 'ਕਰੋੜ'], [100_000, 'ਲੱਖ'], [1000, 'ਹਜ਼ਾਰ']]
  let rest = n
  for (const [size, word] of units) {
    const q = Math.floor(rest / size)
    if (q) parts.push(`${spell(q)} ${word}`)
    rest %= size
  }
  if (rest) parts.push(below1000(rest))
  return parts.join(' ')
}

export const pa: NumberSpeller = {
  spell,
  // 1100–1999 are said in hundreds ("ਉੱਨੀ ਸੌ ਪਚਾਸੀ"); other years as plain numbers.
  year: (n) => (n >= 1100 && n < 2000
    ? [`${BELOW_100[Math.floor(n / 100)]} ਸੌ`, n % 100 ? BELOW_100[n % 100] : ''].filter(Boolean).join(' ')
    : spell(n)),
  rupees: 'ਰੁਪਏ'
}
